import React from "react";
import { useTranslation } from "react-i18next";
import { store } from "../../../../redux/store";
import { showEnquireModal } from "../../../../connected-components/enquireModal/reducer";

export const FooterRight: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="flex justify-start lg:justify-end">
      <button
        onClick={() => store.dispatch(showEnquireModal())}
        className="inline-flex items-center justify-center px-7 py-3 border border-primary border-solid rounded-lg lg:rounded text-black font-medium hover:bg-primary/10 transition-colors"
      >
        {t("footer.enquireNow", "ENQUIRE NOW")}
      </button>
    </section>
  );
};
